var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { cx } from 'emotion';
import { deprecatedProp as deprecated } from './utils';
const DEFAULT = 'default';
const LAYOUT = 'layout';
const MINIMAL = 'minimal';
const Card = (_a) => {
    var { children, header, isMinimal, className, style, type, variant } = _a, rest = __rest(_a, ["children", "header", "isMinimal", "className", "style", "type", "variant"]);
    // isMinimal should take priority here for backwards compatibility
    const cardClassName = cx('card', className, { 'card-minimal': isMinimal || ((variant || type) === MINIMAL), 'card-layout': !isMinimal && ((variant || type) === LAYOUT) });
    return (React.createElement("div", Object.assign({ className: cardClassName, style: style }, rest),
        header && (React.createElement("div", { className: 'card-header' },
            React.createElement("h5", { className: "card-title" }, header))),
        React.createElement("div", { className: 'card-block' }, children)));
};
Card.propTypes = {
    children: PropTypes.node.isRequired,
    header: PropTypes.node,
    isMinimal: PropTypes.bool,
    className: PropTypes.string,
    style: StylePropType,
    variant: PropTypes.oneOf([DEFAULT, LAYOUT, MINIMAL]),
    type: deprecated(PropTypes.oneOf([DEFAULT, LAYOUT, MINIMAL]), 'Use `variant` instead.'),
};
Card.defaultProps = {
    header: undefined,
    isMinimal: false,
    className: '',
    style: {},
};
export default Card;
